export * from './speciality-widget.service';